import { isMobile } from "../utils"
import { LitElement, html, unsafeCSS } from "lit-element"
import { styleMap } from "lit-html/directives/style-map"
import commonStyle from "../common.css"
import style from "./app.css"
/**
 * Appコンポーネント
 */
export default class extends LitElement {
	static styles = [unsafeCSS(style), unsafeCSS(commonStyle)]

	static get properties () {
		return {
			fullHeight: { type: Boolean, attribute: "full-height" }
		}
	}

	/** 画面全体の高さ */
	#height = ""

	constructor () {
		super()
		/**
		 * 画面いっぱいに表示するか
		 * @type {boolean}
		 */
		this.fullHeight = false

		this.#height = isMobile ? `${window.outerHeight}px` : "100vh"
	}

	render () {
		return html`
			<div class="layout-wrapper background" style=${this.layoutWrapStyle}>
				<div class="layout">
					<slot></slot>
				</div>
				<div class="presentations">
					<slot name="presentations"></slot>
				</div>
			</div>
		`
	}

	get layoutWrapStyle () {
		return styleMap({
			height: this.fullHeight ? this.#height : "100%"
		})
	}
}
